import React from 'react';
import { SIA_PERSONALIZATION_FAILED_REASON } from '@/utils/constants/sia';
import { timeAgo } from '@/utils/ts/stringUtils';
import { INotification } from '@Saral-Influencer-Marketing/saral-utils/src/models';
import { useNavigate } from 'react-router-dom';

import RightArrow from '@/components/Icons/icons/RightArrow';

import ButtonComponent from '../../ButtonComponent/ButtonComponent';

interface Props {
  notification: INotification;
  setShowNotificationDropdown: React.Dispatch<React.SetStateAction<boolean>>;
}

const PersonalizationFailedNotification = ({ notification, setShowNotificationDropdown }: Props) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/dashboard/settings?tab=preferences&failure_type=${notification?.content?.failureType}`);
  };
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="w-9 h-9 flex-shrink-0 text-xl flex center items-center">‼️</div>
      <div className="text-div ">
        <h3 className="text-base font-medium text-default">Training Failed for SIA!</h3>
        <p className="text-sm font-normal text-subdued">{notification?.content?.message}</p>

        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={() => {
              handleNavigate();
              setShowNotificationDropdown(false);
            }}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">
              {notification?.content?.failureType === SIA_PERSONALIZATION_FAILED_REASON.BRAND_GUIDELINES_FAILED
                ? 'Update Personalization Guidelines'
                : 'Update Website'}
            </span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default PersonalizationFailedNotification;
